'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var SelectList = require('@narvar/nth-select-list');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var SelectList__default = /*#__PURE__*/_interopDefaultLegacy(SelectList);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const StyledSelectList = styled__default["default"](SelectList__default["default"]).withConfig({
  componentId: "sc-1x534j2-0"
})(["font-family:inherit;"]);

exports.StyledSelectList = StyledSelectList;
